/**
 * Returns `true` while the CRM's not-yet-built pages (Leads, Opportunities, Contacts, …) are shown as
 * preview pages so the team can see the tool's shape (ENT-565). Set `VITE_FF_CRM_PREVIEW=false` to
 * hide them. Default (unset) → shown. Each page is still gated by its CRM key. Build-time constant.
 */
export function useCrmPreviewEnabled(): boolean {
  return import.meta.env.VITE_FF_CRM_PREVIEW !== 'false'
}
